import { WEIGHT_EQUIPMENT_TYPE } from '../../../../constant'

function isBarEquipmentWeightUtil (type) {
  return [
    WEIGHT_EQUIPMENT_TYPE.BARBELL,
    WEIGHT_EQUIPMENT_TYPE.BARBELL_LIGHT,
    WEIGHT_EQUIPMENT_TYPE.EZ_BAR
  ].includes(type)
}

export { isBarEquipmentWeightUtil }
